import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import BrandFormV2 from "../../brand/components/BrandFormV2";
import { fetchCustomerById } from "../../../services/customerService";
import { Customer } from "../../../types/customer";
import { useAuth } from "../../../context/AuthContext";
import { debug } from "../../../utils/debugLogger";

const BusinessProfileCompletion: React.FC = () => {
  const { customerId } = useParams<{ customerId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [customer, setCustomer] = useState<Customer | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { idToken } = useAuth();

  // Get brandId from query parameters if it exists (and is valid)
  const queryParams = new URLSearchParams(location.search);
  const rawBrandId = queryParams.get("brandId");
  const brandId =
    rawBrandId &&
    rawBrandId !== "undefined" &&
    rawBrandId !== "null" &&
    rawBrandId.trim() !== ""
      ? rawBrandId
      : null;

  useEffect(() => {
    const fetchCustomer = async () => {
      if (!customerId) {
        setError("No customer ID provided");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const customerData = await fetchCustomerById(customerId, idToken);
        setCustomer(customerData);
      } catch (err) {
        debug.error("Error fetching customer:", err);
        setError("Failed to load business profile");
      } finally {
        setLoading(false);
      }
    };

    fetchCustomer();
  }, [customerId]);

  const handleBackToDashboard = () => {
    navigate("/");
  };

  if (loading) {
    return (
      <div className="mx-auto flex w-full max-w-4xl justify-center py-16">
        <div className="flex flex-col items-center gap-3">
          <div className="h-12 w-12 animate-spin rounded-full border-2 border-zinc-200 border-t-brand-primary-light" />
          <p className="text-sm text-zinc-600">Loading business profile…</p>
        </div>
      </div>
    );
  }

  if (error || !customerId) {
    return (
      <div className="mx-auto w-full max-w-4xl">
        <div className="rounded-lg border border-red-200 bg-red-50 p-4 shadow-sm ring-1 ring-red-100">
          <div className="flex gap-3">
            <span className="material-icons shrink-0 text-red-500">error</span>
            <div className="min-w-0">
              <p className="text-sm text-red-800">
                {error ||
                  "No business profile selected. Go back to the dashboard and select a business."}
              </p>
              <button
                type="button"
                onClick={handleBackToDashboard}
                className="mt-3 text-sm font-medium text-red-800 underline decoration-red-300 underline-offset-2 hover:text-red-900"
              >
                Return to dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-4xl">
      <BrandFormV2 customer_id={customerId} brandId={brandId} />
    </div>
  );
};

export default BusinessProfileCompletion;
